import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.concat.js";
export var getCookie = function getCookie(name, encode) {
  return (document.cookie.split('; ').filter(function (cookie) {
    return +cookie.indexOf(name + '=') === 0;
  }).pop() || '').replace(/[^=]+=/, '');
};
export var setCookie = function setCookie(k, v) {
  var obj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var d = Object.keys(obj).map(function (k) {
    if (typeof obj[k] === 'number') {
      var expires = new Date();
      expires.setTime(expires.getTime() + obj[k] * 24 * 60 * 60 * 1000);
      obj[k] = expires.toGMTString();
    }

    return "".concat(k, "=").concat(obj[k]);
  }).join(';');
  document.cookie = "".concat(k, "=").concat(v, ";").concat(d);
};
export var setCookieOrigin = function setCookieOrigin(name, value, expriesDays) {
  var encode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var Days = expriesDays || 20;
  var exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000); // 测试用，cookie有效期2分钟
  // exp.setTime(exp.getTime() + 2*60*1000)

  var val = encode ? escape(value) : value;
  document.cookie = name + '=' + val + ';domain=zhuanzhuan.com;path=/;expires=' + exp.toGMTString();
};